import {useAuthState} from "./context/authContext";
import Login from "./pages/user/login";
import NotFound from "./pages/errors/NotFound";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

const theme = createTheme({
    palette: {
        primary: {
            main: '#001933',
        },
        secondary: {
            main: '#E80000',
        },
        info: {
            main: '#23398F',
        },
        error: {
            main: '#FA9999',
        },
        success: {
            main: '#2F9324',
        },
        warning: {
            main: '#FFD88B',
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'Source Sans Pro'
        ].join(','),
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    scrollbarColor: "#B4B4B4 #f4f5fa",
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        backgroundColor: "transparent",
                        width: '8px'
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 10,
                        backgroundColor: "#B4B4B4",
                        minHeight: 24,
                        margin: 2
                    },
                    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                        backgroundColor: "#828285",
                    },
                    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "#828285",
                    },
                    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#828285",
                        width: '9px'
                    },
                    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                        backgroundColor: "#f4f5fa",
                    }
                },
            },
        },
    },
});

function App() {
    const user = useAuthState();
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <BrowserRouter>
                    {(user.isAuthenticated) ?
                        <Routes>
                            <Route path="/" element={<Dashboard/>}/>
                            <Route path="/*" element={<Dashboard/>}/>
                            <Route path="*" element={<NotFound/>}/>
                            <Route path="/loginsam" element={<Login/>}/>
                        </Routes>
                        :
                        <Routes>
                            <Route path="*" element={<Login/>}/>
                            <Route path="/loginsam" element={<Login/>}/>
                        </Routes>
                    }
                </BrowserRouter>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;